import { Stack } from '@mui/system'
import { useTranslation } from 'next-i18next'
import { useContext } from 'react'
import CheckCircle from 'assets/icons/check-circle.svg'
import { Button } from 'components/common/Button'
import { ButtonVariant } from 'components/common/Button/ButtonVariant'
import { BlackText } from 'components/common/common.style'
import { AuthModal } from './AuthModal'
import {
  LinkWithoutDecorationFullWidth,
  LogoContainer,
  TitleText
} from './AuthModal.style'
import { AuthModalContext } from './AuthModalContext'

export const WelcomeModal = () => {
  const { t } = useTranslation('authentication')
  const {
    modalParams: { redirectUrl },
    setModalParams
  } = useContext(AuthModalContext)

  return (
    <AuthModal modalState="WELCOME">
      <Stack spacing={2} alignItems="center">
        <LogoContainer>
          <CheckCircle />
        </LogoContainer>

        <TitleText>{t('welcome.title')}</TitleText>
        <BlackText>{t('welcome.description')}</BlackText>
        <LinkWithoutDecorationFullWidth href={redirectUrl}>
          <Button
            variant={ButtonVariant.Primary}
            label={t('welcome.button.continue')}
            fullWidth
            onClick={() =>
              setModalParams({
                redirectUrl,
                state: 'CLOSED'
              })
            }
          />
        </LinkWithoutDecorationFullWidth>
      </Stack>
    </AuthModal>
  )
}
